import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'insurances';
export const route = 'insurances/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/InsurancesPage')));